import { Directive, Input, HostListener, Optional } from '@angular/core';

import { AbstractValueControlBase } from '../types/abstract-value-control-base';
import { ControlValidateMoment } from '../types/validator.types';
import { ValueControlViewModel } from '../types/control.types';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfControlValidate]'
})
export class ControlValidateDirective {
  @Input('dfControlValidate')
  set control(control: AbstractValueControlBase<ValueControlViewModel>) {
    if (this.controlBase && !control) {
      this._control = this.controlBase;
      return;
    }
    this._control = control;
  }
  get control(): AbstractValueControlBase<ValueControlViewModel> {
    return this._control ? this._control : this.controlBase;
  }

  private _control: AbstractValueControlBase<ValueControlViewModel>;

  constructor(@Optional() private controlBase: AbstractValueControlBase<ValueControlViewModel>) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.control.validateAtMoment(ControlValidateMoment.Input);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    this.control.validateAtMoment(ControlValidateMoment.Blur);
  }

  @HostListener('change', ['$event'])
  onChange(event: any) {
    this.control.validateAtMoment(ControlValidateMoment.Change);
  }
}
